import { Component, ElementRef, inject, input } from '@angular/core';
import { AppMenu } from './app.menu';
import { MenuItem } from 'primeng/api';

@Component({
    selector: 'app-sidebar',
    standalone: true,
    imports: [AppMenu],
    styles: `
        .info {
            text-align: center;
        }
    `,
    template: ` <div class="layout-sidebar">
    <app-menu [menuItems]="menuItems()"></app-menu>
    </div>`
})
export class AppSidebar {
    // Signal input of MenuItem array
    menuItems = input<MenuItem[]>([]);
    el: ElementRef = inject(ElementRef);
}
